export default [
  {
    title: 'Weiterführende Materialen und Tipps',
    items: [
      {
        type: 'component',
        body: 'MORE_MATERIAL_AND_TIPS',
      },
    ],
  },
];



// WEBPACK FOOTER //
// ./src/data/MORE_SOURCES.js